import { forwardRef } from "react";

import styled from "styled-components/macro";

import { columnLetters } from "Importing/Helpers/columnLetters";
import { motion } from "framer-motion";

import FnrIcon, { FnrIconWrapper } from "UI/FnrIcon";
import { FnrToggleItems } from "UI/FnrToggle2";
import { HoverBackground, HoverSelectedBackground } from "UI/HoverChildren";
import { colors as fnColors } from "UI/colors";

export const tabToggleStyles = {
  border: "none",
  background: "transparent",
  pointerEvents: "auto",
};

export const TabCustomHoverElement = styled(HoverBackground)`
  display: none;
`;

export const TabCustomSelectedElement = styled(HoverSelectedBackground)`
  background: none;
  &:after {
    content: "";
    position: absolute;
    height: 4px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #278dc1;
    display: block;
    border-radius: 12px;
  }
`;

export const TabBar = styled.div`
  padding-bottom: 4px;
  padding-top: 12px;
  display: flex;
`;

export const TabWrapper = styled.div`
  & + & {
    margin-left: 24px;
  }

  & a {
    text-decoration: none !important;
  }
`;

export const TabBackground = forwardRef(
  (
    { children, disabled, selected = false, onClick, style, colors },
    forwardedRef
  ) => {
    if (!colors) colors = {};
    if (!colors.disabled) colors.disabled = fnColors.fnGray;
    if (!colors.default) colors.default = fnColors.fnTabSelectedGray;
    if (!colors.selected) colors.selected = fnColors.fnDkBlueGray;
    if (!colors.hover) colors.hover = fnColors.fnBlue;

    return (
      <TabBackgroundWrapper
        ref={forwardedRef}
        disabled={disabled}
        whileHover={{
          color: disabled
            ? colors.disabled
            : selected
            ? colors.selected
            : colors.hover,
        }}
        animate={{
          color: disabled
            ? colors.disabled
            : selected
            ? colors.selected
            : colors.default,
        }}
        onClick={onClick}
        style={style}
      >
        {children}
      </TabBackgroundWrapper>
    );
  }
);

const TabBackgroundWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  color: #596a70;
  font-size: 14px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  & ${FnrIconWrapper} {
    padding-left: 1px;
  }
`;
export const TabText = styled.div`
  font-size: 16px;
  font-weight: 400;
  ${FnrIconWrapper} + & {
    margin-left: 6px;
  }
`;

export const TabItems = styled(FnrToggleItems)`
  padding-left: 16px;
  padding-right: 24px;
`;

const NavBulletWrapper = styled.div`
  font-size: 10px;
  align-self: center;
  margin-bottom: 4px;
  color: ${fnColors.fnGray};
  margin-left: 18px;
  margin-right: 18px;
`;
export const NavBullet = () => {
  return (
    <NavBulletWrapper>
      <FnrIcon fas fa-chevron-right />
    </NavBulletWrapper>
  );
};
